import React, { useContext } from "react";
import { userRepository } from "../../../repository/user.repository";
import { languages } from "../../../dummyData/dummyData";
import { PopupsContext, ACTIONS } from "../../../contexts/PopupsContext";
import ListItem from "../ListItem/ListItem";
import ListItemInfo from "../../molecules/ListItemInfo/ListItemInfo";
import ListItemImgInfo from "../../molecules/ListItemImgInfo/ListItemImgInfo";
import { TYPE_REWARD } from "../RewardEndorsementsList/RewardEndorsementsList";

const RewardEndorsement = ({ data, withManagement }) => {
  const { type, preparedType, description, profile_image_small, receiver, sender, preparedCreatedDate, preparedClaimedDate } = data;
  const { callPopup } = useContext(PopupsContext);

  return (
    <ListItem title={preparedType} subtitle={description} image={profile_image_small} buttons={withManagement && type === TYPE_REWARD && preparedClaimedDate === null ? [
      {
        icon: "checkMark", onClick: () => callPopup({
          type: ACTIONS.POST_CONFIRM,
          payload: {
            header: languages.EN.labels.confirmation,
            content: languages.EN.messages.areYouSureYouWantToConfirm,
            action: () => userRepository.sendClaimReward(data.id),
          },
        }),
      },
    ] : []}>
      <ListItemImgInfo value={`${sender.profile.name} ${sender.profile.surname}`} image={sender.profile.profile_image_small} />
      <ListItemImgInfo value={`${receiver.profile.name} ${receiver.profile.surname}`} image={receiver.profile.profile_image_small} />
      <ListItemInfo value={preparedCreatedDate} />
      <ListItemInfo value={preparedClaimedDate} />
    </ListItem>
  );
};
export default RewardEndorsement;
